import dayjs from 'dayjs'
import { numberWithCommas } from '../../../helpers/number'

export const satangsToBaht = satangs => {
  if (satangs == null) return 0
  return Number(satangs) / 100
}

export const formatBaht = satangs => {
  const baht = satangsToBaht(satangs)
  return `฿${numberWithCommas(baht.toFixed(2))}`
}

export const formatPercent = value => {
  if (value == null) return '-'
  return `${Number(value).toFixed(2)}%`
}

export const formatNumber = value => {
  if (value == null) return '-'
  return numberWithCommas(value)
}

export const formatDate = value => {
  if (!value) return '-'
  return dayjs(value).format('DD MMM YYYY')
}

export const formatDateTime = value => {
  if (!value) return '-'
  return dayjs(value).format('DD MMM YYYY HH:mm')
}

export const formatDays = value => {
  if (value == null) return '-'
  return `${numberWithCommas(value)} days`
}

const MONTH_LABELS = {
  '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr',
  '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Aug',
  '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec'
}

export const summarizeSeasonality = index => {
  if (!index || typeof index !== 'object') return '-'
  const entries = Object.entries(index)
    .map(([month, count]) => [month, Number(count) || 0])
    .filter(([, count]) => count > 0)
  if (entries.length === 0) return '-'

  const max = Math.max(...entries.map(([, count]) => count))
  const peakMonths = entries
    .filter(([, count]) => count === max)
    .map(([month]) => MONTH_LABELS[month] || month)
  const total = entries.reduce((sum, [, count]) => sum + count, 0)

  return `Peak: ${peakMonths.join(', ')} (${max}/${total} orders)`
}

export const SEGMENT_COLORS = {
  vip: 'gold',
  high: 'green',
  medium: 'blue',
  low: 'default',
  new_customer: 'cyan',
  at_risk: 'orange',
  churned: 'red',
  unsegmented: 'default'
}

export const SEGMENT_LABELS = {
  vip: 'VIP',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  new_customer: 'New',
  at_risk: 'At risk',
  churned: 'Churned',
  unsegmented: 'Unsegmented'
}
